import { Directive, Input } from '@angular/core';
import { ComponentService } from "../services/component/component.service";

@Directive()
export abstract class ComponentInputBase {
  public inputs: { [key: string]: { type: string, value: any, options?: string[], displayText?: string, description?: string } } = {};

  constructor(protected componentService: ComponentService) {
    this.inputs = { autoHeight: { type: 'boolean', value: true } };
  }

  @Input() set dynamicInput(inputValue: { [key: string]: { type: string, value: any, options?: string[], displayText?: string, description?: string } }) {
    Object.keys(inputValue).forEach(key => {
      this.inputs[key] = this.componentService.getDynamicInputType(inputValue[key]);
    });
  }

  // Dynamic getter
  protected getInput(key: string): any {
    return this.inputs[key]?.value;
  }

  // Method to check if a key exists in inputs
  protected hasInput(key: string): boolean {
    return key in this.inputs;
  }

  protected setInput(key: string, value: any): void {
    this.inputs[key] = { type: this.inputs[key].type, value: value, options: this.inputs[key].options, displayText: this.inputs[key].displayText, description: this.inputs[key].description };
    }
  }
